import React from 'react';
import { View } from 'react-native';
import { useTheme } from '@/context/ThemeContext';
import { useCoworkerStore } from '@/store';
import Text from '@/components/Typography/Text';
import Icon from '@/components/Icon';

// Web can show the folder context, but project access stays in the native apps.
export default function WorkProjectFolderButton({ taskId, projectName, style, labelStyle }) {
  const { colors } = useTheme();
  const taskName = useCoworkerStore(state => taskId ? state.tasks[taskId]?.localProject?.name : null);
  const name = projectName || taskName;
  if (!name) return null;
  return <View style={[{ flexDirection: 'row', alignItems: 'center', minWidth: 0, gap: 6 }, style]}>
    <Icon name="laptop" size={14} color={colors.text_color_secondary} />
    <Text size="s" numberOfLines={1} style={labelStyle}>{name}</Text>
  </View>;
}
